var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-menu',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"contextmenu",style:(_vm.style),attrs:{"selectedKeys":_vm.selectedKeys},on:{"click":_vm.handleClick}},_vm._l((_vm.itemList),function(item){return _c('a-menu-item',{key:item.key},[_vm._v("\n    "+_vm._s(item.text)+"\n  ")])}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c40fd9c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu/Contextmenu.vue
// module id = null
// module chunks = 